import * as React from 'react';

import {Button} from 'shells/button/button';
import {Card} from 'shells/card/card';
import {colors} from 'shells/colors/colors';
import {Divider} from 'shells/layout/divider';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';
import {Body} from 'shells/typography/body';

import type {GetPotentialMeetings_potentialMeetings as Meeting} from 'nutshell-graphql-types';

import {getServiceTypeIcon, getServiceTypeColor} from '../../../external-meetings/helpers';

import {getRecordingStatusText} from './helpers';

type Props = {
    meeting: Meeting;
    onClick?: (e: React.SyntheticEvent<any>) => void;
    isSelected: boolean;
};

export const MeetingCard = (props: Props) => {
    return (
        <Card
            hasBorder={true}
            hasShadow={true}
            onClick={props.onClick}
            leftLineColor={
                props.isSelected ? getServiceTypeColor(props.meeting.serviceType) : undefined
            }
        >
            <div className='flex justify-sb pad-8'>
                <StackLegacy spacing={8} alignCenter={true} isHorizontal={true}>
                    {getServiceTypeIcon(props.meeting.serviceType)}
                    <StackLegacy spacing={0}>
                        <div style={{maxWidth: props.isSelected ? '380px' : '150px'}}>
                            <Body
                                size='small'
                                color={props.meeting.topic ? 'dark' : 'light'}
                                isItalic={!props.meeting.topic}
                                nowrap={true}
                                truncate={{type: 'block'}}
                                isBold={true}
                            >
                                {props.meeting.topic || 'No topic'}
                            </Body>
                        </div>
                        <StackLegacy isHorizontal={true} spacing={0}>
                            <FormattedTimestamp
                                datetime={props.meeting.startTime}
                                format={FormattedTimestamp.formats.time}
                            />
                            <Divider variant='dot' color={colors.greyLt} spacing={4} />
                            <Body size='small'>
                                {props.meeting.participants.length}{' '}
                                {props.meeting.participants.length === 1 ? 'person' : 'people'}
                            </Body>
                        </StackLegacy>
                        <div>
                            <Body size='small'>
                                {props.meeting.durationMinutes
                                    ? `${props.meeting.durationMinutes} mins`
                                    : 'In progress'}
                            </Body>
                            <Divider variant='dot' color={colors.greyLt} spacing={4} />
                            <Body size='small'>
                                {getRecordingStatusText(props.meeting.recordingStatus)}
                            </Body>
                        </div>
                    </StackLegacy>
                </StackLegacy>
                <Button variant='text-primary' size='small'>
                    {props.isSelected ? 'Change' : 'Select'}
                </Button>
            </div>
        </Card>
    );
};
